import { useArticles } from "./useArticles";
export var useAboutFaireArticles = function useAboutFaireArticles() {
  var articles = useArticles();
  return [articles.FAQ.RETAILER_WHAT_IS_FAIRE, articles.FAQ.WHERE_IS_FAIRE_AVAILABLE, articles.FAQForProspectiveBrands.BECOME_BRAND, articles.FAQForProspectiveBrands.FAIRE_COST];
};